<template>
    <div class="alphaKeys base-button">
        <div>
            <slot name="alphaName"></slot>
        </div>
    </div>
</template>

<script>
export default { 
    name: 'AlphaKeys',
    data() {
        return {
            btnAct: 1
        }
    },
    methods: {
    },

}
</script>

<style scoped>

.alphaKeys{
        width: .733333rem;
        height: .666667rem;
        font-size: .4rem;
        line-height: .653333rem;
        background: radial-gradient(#3f3e3f, #221f20 80%);
        
        /* 这个值需要重新计算 */
        margin-left: .2rem;
    }

    .alphaKeys::before{
        height: .4rem;
        left: -1px;
        top: .09rem;
    }

    .alphaKeys::after{
        height: .4rem;
        top: .09rem;
    }
</style>